import { track } from "@/lib/analytics";
import { useState } from "react";
import { PillLink } from "@/components/site/Buttons";
import { Chips, FormError, Honeypot, SentPanel, TextArea, TextInput, useEnquiry } from "@/components/forms/fields";
import { DISCIPLINES } from "@/content/roles";

const empty = (role) => ({ name: "", email: "", role, discipline: "", location: "", profile_url: "", cv_url: "", hardest_build: "", why: "", hp: "" });

export const ApplicationForm = ({ role = "open", roleTitle }) => {
  const [f, setF] = useState(() => empty(role));
  const [localErr, setLocalErr] = useState("");
  const { status, reference, error, submit, reset } = useEnquiry("/enquiries/application");
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));
  const open = role === "open";

  const invalid = (message) => { track("application_validation_error"); setLocalErr(message); };
  const onSubmit = (e) => {
    e.preventDefault();
    if (open && !f.discipline) return invalid("Choose the discipline closest to yours.");
    if (f.hardest_build.trim().length < 20) return invalid("Tell us a bit more about what you've built (20+ characters).");
    setLocalErr("");
    return submit({ ...f, role });
  };

  if (status === "sent") return <SentPanel reference={reference} onReset={() => { setF(empty(role)); reset(); }} testId="application-form-success" />;

  return (
    <form data-clarity-mask="true" data-analytics-form="application" onSubmit={onSubmit} className="relative space-y-9" data-testid={`application-form-${role}`}>
      <Honeypot value={f.hp} onChange={set("hp")} />
      {roleTitle && <p className="eyebrow text-signal">Applying for · {roleTitle}</p>}
      <div className="grid gap-8 sm:grid-cols-2">
        <TextInput label="Full name" required value={f.name} onChange={set("name")} autoComplete="name" maxLength={120} testId="application-name-input" />
        <TextInput label="Email" type="email" required value={f.email} onChange={set("email")} autoComplete="email" testId="application-email-input" />
        <TextInput label="Where you're based" value={f.location} onChange={set("location")} maxLength={120} testId="application-location-input" />
        <TextInput label="LinkedIn, GitHub or portfolio" value={f.profile_url} onChange={set("profile_url")} placeholder="https://" maxLength={300} testId="application-profile-input" />
      </div>
      {open && <Chips label="Your discipline" required options={DISCIPLINES} value={f.discipline} onChange={set("discipline")} testIdPrefix="application-discipline" />}
      <TextInput label="Link to CV" hint="Drive, Dropbox or personal site" value={f.cv_url} onChange={set("cv_url")} placeholder="https://" maxLength={300} testId="application-cv-input" />
      <TextArea label="The hardest thing you've built, and your part in it" required value={f.hardest_build} onChange={set("hardest_build")} maxLength={5000} rows={6} testId="application-hardest-input" />
      <TextArea label="Why x1025, why now?" value={f.why} onChange={set("why")} maxLength={3000} rows={4} testId="application-why-input" />
      {localErr && <p className="text-[14px] text-caution" data-testid="application-form-validation">{localErr}</p>}
      <FormError message={error} testId="application-form-error" />
      <div className="flex flex-wrap items-center gap-5">
        <PillLink type="submit" disabled={status === "sending"} testId="application-submit-button">{status === "sending" ? "Sending…" : "Send application"}</PillLink>
        <p className="text-[13px] text-fg-3">Read by the founders, personally.</p>
      </div>
    </form>
  );
};
